import { RedirectPage } from "components/UI/RedirectPage/RedirectPage.tsx";
import { Route as TrackingToolsFromPage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/s2s-postback";
import { Route as TrackingToolsToPage } from "routes/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/_layout/tracking-api";
import { PermissionEnum } from "types/enums.ts";
import { createTenantFileRoute, RouteStaticData } from "utils/createTenantFileRoute.ts";

const staticData: RouteStaticData = {
    permissions: [PermissionEnum.ToolTrackingOutgoing, PermissionEnum.ToolTrackingIncoming],
    showInSideMenu: true,
    sideMenuParent: "lazy", // Is defined below after parent route is initialized
    label: "pages.tool.tracking.title",
    sort: 5,
    redirects: [TrackingToolsFromPage, TrackingToolsToPage],
    defaultRedirect: TrackingToolsFromPage,
};

export const Route = createTenantFileRoute("/_authenticated/$tenantSlug/_layout/tool/_layout/tracking/")({
    component: TrackingToolsPage,
    staticData,
});

function TrackingToolsPage() {
    return <RedirectPage />;
}

// Delay sideMenuParent after parent route is initialized
import("routes/_authenticated/$tenantSlug/_layout/tool/index.tsx").then((mod) => {
    staticData.sideMenuParent = mod.Route;
});
